import { FooterTranslation } from '@/assets/locales/layouts/footer/footer.translation.en.ts';

export const footerTranslation: FooterTranslation = {
  contact: 'Kontakt',
  privacyPolicy: 'Polityka Prywatności',
  termsConditions: 'Regulamin',
};
